import { ListItem, Thumbnail } from '@bynder/design-system';
import { IconCode, IconSpreadsheet } from '@bynder/icons';
import { useContext } from 'react';
import { TeaClientContext } from './tea-editor-controls.tsx';

export function InsertControl() {
  const { editor } = useContext(TeaClientContext);

  return (
    <>
      <ListItem
        onClick={() => {
          editor
            ?.chain()
            .insertTable({ rows: 3, cols: 3, withHeaderRow: false })
            .focus()
            .run();
        }}
        thumbnail={<Thumbnail icon={<IconSpreadsheet />} variant="clean" />}
        // biome-ignore lint/a11y/useSemanticElements: we're using the design system component here so we can't swap it out for a button
        role="button"
        aria-label="Insert table"
      >
        Table
      </ListItem>
      <ListItem
        onClick={() => {
          editor?.chain().setCodeBlock().focus().run();
        }}
        thumbnail={<Thumbnail icon={<IconCode />} variant="clean" />}
        // biome-ignore lint/a11y/useSemanticElements: we're using the design system component here so we can't swap it out for a button
        role="button"
        aria-label="Insert code block"
      >
        Code block
      </ListItem>
    </>
  );
}
